import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from 'src/hooks/useTheme';
import { cn } from 'src/lib/utils';

export function ThemeToggle({ className }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={isDark}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      className={cn(
        'flex h-8 w-8 items-center justify-center rounded-md border transition-colors',
        'border-[var(--border)] bg-[var(--surface)] text-[var(--text-faint)]',
        'hover:border-[var(--primary)] hover:bg-[var(--primary-light)] hover:text-[var(--primary)]',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]',
        className
      )}
    >
      {isDark ? (
        <Sun size={15} strokeWidth={1.8} aria-hidden="true" />
      ) : (
        <Moon size={15} strokeWidth={1.8} aria-hidden="true" />
      )}
    </button>
  );
}

export default ThemeToggle;
